import { WeatherContext } from 'pages/Forecast';
import React, { useContext } from 'react';
import 'styles/global.css';
import DataGridDisplay from 'components/DataGridDisplay/DataGridDisplay';
import { GetWeatherDateString } from 'utils/stringUtils';
import { GetQualityColor } from 'utils/colorUtils';
import { PiWavesBold } from 'react-icons/pi';
import { Container } from 'react-bootstrap';

export default function AirQualityObservation() {
  const weatherContext = useContext(WeatherContext);

  return (
    <Container fluid>
      <h3 className="d-none d-md-block mt-2 border-bottom border-secondary">
        Air Quality Observation Locations
      </h3>
      <h6 className="d-block d-md-none mt-2 border-bottom border-secondary">
        Air Quality Observation Locations
      </h6>

      {weatherContext?.airQuality?.observation &&
        weatherContext?.airQuality?.observation?.length > 0 && (
          <div className="row gy-3">
            {weatherContext.airQuality.observation.map((item, index) => (
              <div key={index} className="col-12 col-lg-6">
                <DataGridDisplay
                  title={GetWeatherDateString(new Date(item?.iso8601))}
                  icon={<PiWavesBold size={25} color={GetQualityColor(item?.category)} />}
                >
                  <div className="d-flex flex-row justify-content-between">
                    <div>{`Concentration: ${item.concentration || '*'}ppb`}</div>
                    <div>{`Category: ${item.category || '*'}`}</div>
                  </div>
                </DataGridDisplay>
              </div>
            ))}
          </div>
        )}

      {(!weatherContext?.airQuality?.observation ||
        weatherContext?.airQuality?.observation?.length === 0) && (
        <div>
          <h5 className="d-none d-md-block">No Air Quality Observations near you</h5>
          <p className="d-block d-md-none">No Air Quality Observations near you</p>
        </div>
      )}
    </Container>
  );
}
